import { TOOL_DISPLAY_SHIMMER_TEXT_DURATION_S } from "./toolWidgetAnimationConstants";

/**
 * In-flight tool call label: gradient “shimmer” to signal activity
 * (duration aligned with `animate-shimmer-text` in Tailwind config).
 */
export const AnimatedToolText = ({ children }: { children: string }) => (
  <span
    className="animate-shimmer-text bg-clip-text text-xs font-medium leading-5 text-transparent"
    style={{
      backgroundImage:
        "linear-gradient(90deg, #6b7280 0%, #6b7280 38%, #e5e7eb 49%, #3b82f6 55%, #6b7280 70%, #6b7280 100%)",
      backgroundSize: "300% 100%",
      animationDuration: `${TOOL_DISPLAY_SHIMMER_TEXT_DURATION_S}s`,
    }}
  >
    {children}
  </span>
);
